// Funzione che crea il pdf con il listino prezzi del servizio di gradazione
import {jsPDF} from "jspdf";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";
import { CURRENCY_EURO, parseAmount, parseCategoryName } from "../utils";


const tab = "        "
const space = " "
const CELL_HEIGHT = 5

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const addFooters = (doc) => {
  const pageCount = doc.internal.getNumberOfPages()

  doc.setFont('helvetica', 'italic')
  doc.setFontSize(8)
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, doc.internal.pageSize.getHeight() - 10, {
      align: 'center'
    })
  }
}



const parsePrice = (price) => {
  if (price)
    return parseAmount(price) + CURRENCY_EURO
  else
    return I18n.t('js.PDFGenerator.gradingPriceList.notAvailablePrice')
}

const categoryItemSortingValue = (i) => {
  switch(i.parsed_category) {
    case 'singles':
      return 0
    case 'booster_pack':
      return 1
    default:
      return 2
  }
}


const sortItemsByCategory = (a, b) => {
  if (categoryItemSortingValue(a) < categoryItemSortingValue(b))
    return -1;
  if (categoryItemSortingValue(a) > categoryItemSortingValue(b))
    return 1;
  return 0;
}


export const gradingPriceListTemplate = (graderCompany) => {

  const doc = new jsPDF({orientation: "landscape"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')
  var img = new Image()
  img.src = '/images/square.png'
  doc.addImage(img, 'png', 10, 1, 15, 15)
  doc.setFontSize(24)
  writeBoldText(doc, graderCompany.meta_name, 28, 13)

  doc.line(10, 18, 200, 18, 'FD')
  doc.setFontSize(18)
  doc.text(I18n.t('js.PDFGenerator.gradingPriceList.title'), 10, 26);



  // Tabella con i costi di gradazione
  if (graderCompany.encasing_items) {
    doc.setFontSize(18);

    const samePriceRendered = {
      singles: false,
      booster_pack: false,
      sealed: false
    }
    var tableContent = []
    const encasingItems = Object.values(graderCompany.encasing_items).sort(sortItemsByCategory)
    for (const encasingItem of encasingItems) {
      const parsedCategory = encasingItem.parsed_category

      if (graderCompany[`${parsedCategory}_same_prices`]) {
        if (!samePriceRendered[parsedCategory]) {
          if (encasingItem.sleeve)
            tableContent.push(
              [
                I18n.t(`js.PDFGenerator.gradingPriceList.${parsedCategory}`),
                I18n.t(`js.PDFGenerator.gradingPriceList.${parsedCategory}_sleeve`),
                parsePrice(encasingItem.sleeve)
              ]
            );

          if (encasingItem.case)
            tableContent.push(
              [
                I18n.t(`js.PDFGenerator.gradingPriceList.${parsedCategory}`),
                I18n.t(`js.PDFGenerator.gradingPriceList.${parsedCategory}_case`),
                parsePrice(encasingItem.case)
              ]
            )

          samePriceRendered[parsedCategory] = true
        }
      } else {
        if (encasingItem.sleeve)
          tableContent.push(
            [
              encasingItem.description ? encasingItem.description : (encasingItem.category ? parseCategoryName(encasingItem.category) : (encasingItem.name ? encasingItem.name : '')),
              I18n.t(`js.PDFGenerator.gradingPriceList.${parsedCategory}_sleeve`),
              parsePrice(encasingItem.sleeve)
            ]
          )

        if (encasingItem.case)
          tableContent.push(
            [
              encasingItem.description ? encasingItem.description : (encasingItem.category ? parseCategoryName(encasingItem.category) : (encasingItem.name ? encasingItem.name : '')),
              I18n.t(`js.PDFGenerator.gradingPriceList.${parsedCategory}_case`),
              parsePrice(encasingItem.case)
            ]
          )
      }
    }


    doc.autoTable({
      theme: 'plain',
      head: [[
        I18n.t('js.PDFGenerator.gradingPriceList.description'),
        I18n.t('js.PDFGenerator.gradingPriceList.gradingOn'),
        I18n.t('js.PDFGenerator.gradingPriceList.gradingCost')
      ]],

      body: tableContent,
      margin: {left: 10, right: 10},
      startY: doc.pageCount > 1 ? doc.lastAutoTable.finalY + 10 : 40,
      headStyles: {
        font: 'Koruri-Bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        align: 'center',
        minCellHeight: CELL_HEIGHT
      },
      bodyStyles: {
        font: 'Koruri-Regular',
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        align: 'center',
        minCellHeight: CELL_HEIGHT
      },
      alternateRowStyles: {
        fillColor: [230, 230, 230]
      }
    })
  }



  // Note finali
  doc.setFontSize(10);
  doc.text('*' + I18n.t("js.PDFGenerator.gradingPriceList.note"), 10, doc.lastAutoTable.finalY + 10);


  addFooters(doc)
  var pdfName= 'Grading_Price_List.pdf'
  doc.save(pdfName);
}
